import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionSubmitLogin,
    actionSubmitLoginSuccess,
    actionSubmitLoginFailed,
    actionGetUserById,actionClearUserDataById
 } from './login.reducer';
import { auth } from '../../config/firebase';

export const useLoginActions = () => {
  const dispatch = useDispatch();
const logout = async () => {
    await auth.signOut(); // Firebase logout
    dispatch(actionClearUserDataById()); // clear Redux user state
  };
  return bindActionCreators(
    {
        actionSubmitLogin,
        actionSubmitLoginSuccess,
        actionSubmitLoginFailed,
        actionGetUserById,
        actionClearUserDataById,
        logout,
    },
    dispatch
  );
};